import {
    Box,
    Checkbox,
    CircularProgress,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Typography,
} from '@mui/material';
import { Roi } from '~/domain/dicom/dicomstructureset';
import StructureRow from './StructureRow';

type StructuresTableProps = {
    isLoading?: boolean;
    structures: Roi[];
    selectedStructures: Roi[];
    onSelect: (structure: Roi) => void;
};

const TableLoader = () => (
    <TableRow>
        <TableCell colSpan={3} align="center" height={80}>
            <CircularProgress size={24} />
            <Typography variant="body2" mt={0.5}>
                Loading datasets...
            </Typography>
        </TableCell>
    </TableRow>
);

const StructuresTable = ({
    isLoading,
    structures,
    selectedStructures,
    onSelect,
}: StructuresTableProps) => {
    const handleSelectAll = (event: React.ChangeEvent<HTMLInputElement>) => {
        const isChecked = event.target.checked;
        structures.forEach((structure) => {
            if (isChecked && !selectedStructures.includes(structure)) {
                onSelect(structure);
            } else if (!isChecked && selectedStructures.includes(structure)) {
                onSelect(structure);
            }
        });
    };

    return (
        <TableContainer
            sx={(theme) => ({
                height: '200px',
                overflowY: 'auto',
                borderRadius: `${theme.shape.borderRadius}px`,
                border: `1px solid ${theme.palette.divider}`,
            })}
        >
            <Table stickyHeader size="small">
                <TableHead>
                    <TableRow>
                        <TableCell
                            align="left"
                            sx={{ width: '40%', paddingLeft: 0.5 }}
                        >
                            <Box display="flex" alignItems={'center'}>
                                <Checkbox
                                    size="small"
                                    color="primary"
                                    sx={{ mr: 0.5 }}
                                    checked={
                                        selectedStructures.length ===
                                        structures.length
                                    }
                                    indeterminate={
                                        selectedStructures.length > 0 &&
                                        selectedStructures.length <
                                            structures.length
                                    }
                                    onChange={handleSelectAll}
                                />
                                STRUCTURE{' '}
                                <Typography
                                    sx={{ ml: 0.5 }}
                                    fontSize={12}
                                    variant="body2"
                                >
                                    ({selectedStructures.length})
                                </Typography>
                            </Box>
                        </TableCell>
                        <TableCell align="left" sx={{ width: '20%' }}>
                            TYPE
                        </TableCell>
                        <TableCell align="right" sx={{ width: '30%' }}>
                            STATUS
                        </TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {isLoading ? (
                        <TableLoader />
                    ) : (
                        structures.map((structure, i) => (
                            <StructureRow
                                key={i}
                                structure={structure}
                                onSelect={onSelect}
                                selectedStructures={selectedStructures}
                            />
                        ))
                    )}
                </TableBody>
            </Table>
        </TableContainer>
    );
};

export default StructuresTable;
